import { render, staticRenderFns } from "./VideoChat.vue?vue&type=template&id=2646dd1c&scoped=true&"
import script from "./VideoChat.vue?vue&type=script&lang=js&"
export * from "./VideoChat.vue?vue&type=script&lang=js&"
import style0 from "./VideoChat.vue?vue&type=style&index=0&id=2646dd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646dd1c",
  null
  
)

export default component.exports